module.exports = __webpack_public_path__ + "images/workbench_logo.png";